
import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListSong(filter, authorization, isAdmin) {
  const url = isAdmin ? `${API_URL}/admin/content/list-submission` : `${API_URL}/dashboard/content/list-song`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editSubmissionSong(song, authorization) {
  const url = `${API_URL}/dashboard/content/update-content-song`;
  return axios({
    url,
    method: 'post',
    data: song,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updateAlbumOnly(song, authorization) {
  const url = `${API_URL}/dashboard/content/set-album-only`;
  return axios({
    url,
    method: 'post',
    data: song,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addSubmissionSong(song, authorization, onUploadProgress) {
  const url = `${API_URL}/dashboard/content/create-content-song`;
  return axios({
    url,
    method: 'post',
    data: song,
    headers: {
      // 'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addSong(song, authorization, onUploadProgress) {
  const url = `${API_URL}/admin/content/create-content`;
  return axios({
    url,
    method: 'post',
    data: song,
    headers: {
      // 'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editSong(song, authorization, onUploadProgress) {
  const url = `${API_URL}/admin/content/update-song`;
  return axios({
    url,
    method: 'post',
    data: song,
    headers: {
      // 'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListGenreSong(authorization) {
  const url = `${API_URL}/dashboard/genre/list`;
  return axios({ url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailSubmission(idSubmission, authorization) {
  const url = `${API_URL}/admin/content/detail-submission/${idSubmission}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addSubmitSubmissionProcess(submissionData, authorization) {
  const url = `${API_URL}/admin/content/process-submission`;
  return axios({
    url,
    method: 'post',
    data: submissionData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addSubmitSubmissionPublish(submissionData, authorization) {
  const url = `${API_URL}/admin/content/publish-submission`;
  return axios({
    url,
    method: 'post',
    data: submissionData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addSubmitSubmissionUnpublish(submissionData, authorization) {
  const url = `${API_URL}/admin/content/unpublish-submission`;
  return axios({
    url,
    method: 'post',
    data: submissionData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function countSubmissionContent(status, published = null, authorization, id = null) {
  // console.log('id',id);
  let url = id !== null ? `${API_URL}/admin/content/count-submission-artist?status=${status}&artist_id=${id}` : `${API_URL}/admin/content/count-submission?status=${status}`;
  if (published) {
    url += '&published=1';
  } else {
    url += '&published=0';
  }
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteSubmission(submissionData, authorization, isAdmin) {
  const url = isAdmin ? `${API_URL}/admin/content/delete-submission` : `${API_URL}/dashboard/content/delete-song`;
  return axios({
    url,
    method: 'post',
    data: submissionData,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListSongByArtist(filter, authorization, id) {
  const url = `${API_URL}/admin/user-artist/detail/${id}/song`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getTags(filter, authorization) {
  const url = `${API_URL}/admin/content/search-tag`;
  return axios({ url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function saveTags(data, authorization) {
  const url = `${API_URL}/admin/content/add-tag`;
  return axios({ url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function addSongFileTemp(file, authorization, onUploadProgress) {
  const url = `${API_URL}/admin/album/upload-temp-file`;
  return axios({
    url,
    method: 'post',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
    onUploadProgress,
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function uploadLyrics(data, authorization) {
  const url = `${API_URL}/admin/content/add-lyric`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/song.js